import {
  GET_ADMINISTRATION_AUTOMATED_INVOICES,
  GET_ADMINISTRATION_AUTOMATED_INVOICE,
  CREATE_ADMINISTRATION_AUTOMATED_INVOICE,
  UPDATE_ADMINISTRATION_AUTOMATED_INVOICE,
  COMPLETE_ADMINISTRATION_AUTOMATED_INVOICE,
  WEIRD_ADMINISTRATION_AUTOMATED_INVOICE,
  CANCEL_ADMINISTRATION_AUTOMATED_INVOICE,
  DESTROY_ADMINISTRATION_AUTOMATED_INVOICE,
  UPLOAD_ADMINISTRATION_AUTOMATED_INVOICE,
  ADMINISTRATION_AUTOMATED_INVOICE_STATUS_UPDATE,
} from "./actions";

export function AdministrationAutomatedInvoicesReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_ADMINISTRATION_AUTOMATED_INVOICES}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case ADMINISTRATION_AUTOMATED_INVOICE_STATUS_UPDATE: {
      const newItem = action.payload?.invoice;
      if (!newItem || !newItem.id) return state;
      const newState = _.clone(state);
      newState[newItem.id] = newItem;
      return newState;
    }
    case `${GET_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`:
    case `${CREATE_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`:
    case `${UPDATE_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`:
    case `${COMPLETE_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`:
    case `${WEIRD_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`:
    case `${CANCEL_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_ADMINISTRATION_AUTOMATED_INVOICE}_FULFILLED`: {
      let newState = _.clone(state);
      const deletedItem = action.payload.data;
      const id = _.get(deletedItem, "id");
      newState = _.filter(newState, (i) => i.id != id);
      return newState;
    }
    default:
      return state;
  }
}

// Move this to the reducer page
// import { AdministrationAutomatedInvoicesReducer } from "modules/administration/automated_invoices/reducer"

// administration_automated_invoices:AdministrationAutomatedInvoicesReducer,

// Temp Invoices reducer
export function AdministrationAutomatedInvoicesTempReducer(state = {}, action) {
  switch (action.type) {
    case `${UPLOAD_ADMINISTRATION_AUTOMATED_INVOICE}`: {
      return action.data;
    }
    default:
      return state;
  }
}
